import emojione from 'emojione';
//import sprites from 'emojione/assets/sprites/emojione.sprites.svg';

export default {
  install(Vue, options = {
    imageType: 'png',
    sprites: false
  }) {
    Object.assign(emojione, options);
    if (emojione.sprites && emojione.imageType === 'svg') {
      emojione.imagePathSVGSprites = sprites;
    }

    Vue.filter('emoji', (value, method = 'toImage') => {
      return emojione[method](value);
    })
  }
}
